"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var BrandsBannersList = /** @class */ (function (_super) {
    __extends(BrandsBannersList, _super);
    function BrandsBannersList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchISOInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    BrandsBannersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                dimensionsFilter: data.dimensionsFilter,
                geometryFilter: data.geometryFilter,
                typesFilter: data.typesFilter
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchISOFilter: [],
            searchISOValue: "",
            searchTitleFilter: [],
            searchTitleValue: "",
            dimensionsFilter: [],
            geometryFilter: [],
            typesFilter: []
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    BrandsBannersList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandsBannersList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    BrandsBannersList.prototype.doDeprecateAction = function (Key, Title, deprecate) {
        this.props.data.doSetIsDeprecated(Key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u0430\u043D\u043D\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u043C"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u0430\u043D\u043D\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u043C"));
            }
        });
    };
    BrandsBannersList.prototype.getLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i,
                " \u043D\u043E\u043C\u0435\u0440 "));
        }
        return _ret;
    };
    BrandsBannersList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } }, this.getLevelsArray()));
    };
    BrandsBannersList.prototype.doMorection = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.doSetOrderNumber(record.key, _level, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0434\u043B\u044F \u0431\u0430\u043D\u043D\u0435\u0440\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    BrandsBannersList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    BrandsBannersList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    BrandsBannersList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    BrandsBannersList.prototype.onClearISOFilter = function () {
        this.setState({ searchISOFilter: [], searchISOValue: "" });
    };
    BrandsBannersList.prototype.onChangeISOFilter = function (e) {
        this.setState({ searchISOValue: e.target.value });
    };
    BrandsBannersList.prototype.onConfirmISOFilter = function () {
        this.setState({ searchISOFilter: [this.state.searchISOValue] });
    };
    BrandsBannersList.prototype.getColumns = function () {
        var _this = this;
        var _iso_filter = this.state.searchISOFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [
            {
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                },
                sorter: function (a, b) { return a.title.localeCompare(b.title); },
            }, {
                title: 'Url баннера',
                dataIndex: this.props.data.dk_banner_url,
                key: this.props.data.dk_banner_url,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchISOInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E url", value: _this.state.searchISOValue, onChange: _this.onChangeISOFilter.bind(_this), onPressEnter: function () { _this.onConfirmISOFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmISOFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearISOFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _iso_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.banner_url.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchISOInput.focus();
                        });
                    }
                },
                sorter: function (a, b) { return a.banner_url.localeCompare(b.banner_url); },
            }, {
                title: 'Брэнд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Номер п/п',
                dataIndex: this.props.data.dk_order_number,
                key: this.props.data.dk_order_number,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreActionsDropDownMenu(record), trigger: ['click'] },
                        React.createElement(antd_1.Button, { style: { width: 120, minWidth: 120, maxWidth: 120 } },
                            "\u041D\u043E\u043C\u0435\u0440 ",
                            record.order_number,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 130,
            }, {
                title: 'Размеры Ш/В',
                dataIndex: this.props.data.dk_width,
                key: this.props.data.dk_width,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.width,
                        "/",
                        record.height,
                        " px"));
                },
                width: 150,
                filters: this.state.dimensionsFilter,
                filterMultiple: true,
                onFilter: function (value, record) { return (record.width + "/" + record.height + " px").includes(value); }
            }, {
                title: 'Геометрия',
                dataIndex: this.props.data.dk_geometry_type_title,
                key: this.props.data.dk_geometry_type_title,
                align: "center",
                width: 150,
                filters: this.state.geometryFilter,
                filterMultiple: true,
                onFilter: function (value, record) { return ("" + record.geometry_type_title).includes(value); }
            }, {
                title: 'Тип',
                dataIndex: this.props.data.dk_image_type_title,
                key: this.props.data.dk_image_type_title,
                align: "center",
                width: 100,
                filters: this.state.typesFilter,
                filterMultiple: true,
                onFilter: function (value, record) { return ("" + record.image_type_title).includes(value); }
            }, {
                title: 'Кол-во стран',
                dataIndex: this.props.data.dk_countries_count,
                key: this.props.data.dk_countries_count,
                align: "center",
                width: 120,
                render: function (text, record, idx) {
                    if (record.is_all_country) {
                        return (React.createElement("div", null,
                            React.createElement("b", null, "\u0412\u0421\u0415")));
                    }
                    return (React.createElement("div", null, record.countries_count));
                },
            }, {
                title: 'Устарел',
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 150
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 110
            }
        ];
    };
    BrandsBannersList.prototype.onConfigClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    BrandsBannersList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandsBannersList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u0430\u043D\u043D\u0435\u0440 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandsBannersList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    BrandsBannersList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    BrandsBannersList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    BrandsBannersList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                        React.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                flexWrap: "nowrap"
                            } },
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                    " [",
                                    record.key,
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                                    " [",
                                    record.date_added2.format(_this.props.state.getDateTimeFormat()),
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                                    " [",
                                    record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                                    "]")),
                            React.createElement("div", null,
                                React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: "" + _this.props.data.DATA.cdn_baseurl + record.banner_url })))));
                }, scroll: { x: true } })));
    };
    return BrandsBannersList;
}(React.Component));
exports.default = BrandsBannersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_banners_list/ui/component/BrandsBannersList.tsx
// module id = 2406
// module chunks = 0